module.exports = __webpack_public_path__ + "img/British Virgin Islands.0f6fd174.svg";